// Copyright 2025, University of Maryland, All Rights Reserved
interface OverallAssessmentData {
  estimated_completion_time_minutes?: number | string;
  average_difficulty?: number | string;
  recommendations?: string[];
}

interface OverallAssessmentProps {
  data: OverallAssessmentData;
  documentType?: string;
}

export function OverallAssessment({ data, documentType }: OverallAssessmentProps) {
  // Check if this is a syllabus or similar document type
  const isSyllabus = documentType?.toLowerCase().includes('syllabus');
  const shouldShowTime = !isSyllabus && data.estimated_completion_time_minutes;

  return (
    <div className="bg-white p-8 rounded-xl shadow-lg pdf-page-break-avoid">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
        <span className="text-3xl mr-3">🎯</span>
        Overall Assessment
      </h2>

      <div className={`grid grid-cols-1 ${shouldShowTime ? 'md:grid-cols-2' : 'md:grid-cols-1'} gap-6`}>
        {shouldShowTime && (
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <div className="text-3xl font-bold text-blue-600 mb-2">
              {data.estimated_completion_time_minutes}
            </div>
            <div className="text-sm text-gray-600">Minutes to Complete</div>
          </div>
        )}

        {data.average_difficulty && (
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <div className="text-3xl font-bold text-green-600 mb-2">
              {data.average_difficulty}
            </div>
            <div className="text-sm text-gray-600">
              {isSyllabus ? 'Average Completeness Score' : 'Average Difficulty'}
            </div>
          </div>
        )}
      </div>

      {data.recommendations && data.recommendations.length > 0 && (
  <div className="mt-6 bg-gray-50 p-6 rounded-lg shadow-md">
    <h3
      id="recommendations-heading"
      className="text-lg font-semibold text-blue-600 mb-4"
    >
      Recommendations
    </h3>
    <ul
      className="space-y-2 list-disc list-inside"
      aria-labelledby="recommendations-heading"
    >
      {data.recommendations.map((rec: string, index: number) => (
        <li
          key={index}
          className="text-sm text-gray-700 pl-2"
        >
          {rec}
        </li>
      ))}
    </ul>
  </div>
)}
    </div>
  );
}
